import React, { useEffect, useState } from "react";
import { classNames } from "../../helpers/classNames";

const Search = ({
  isDebounce,
  placeholder = "Search",
  divClasses,
  inputClasses,
  iconClasses,
  iconPosition = "right",
  searchValue,
  resetKeyword = false,
  icon = "fa-regular fa-magnifying-glass",
  search = () => {},
  onKeyDown = () => {},
  setResetKeyword = () => {},
}) => {
  const [isFocused, setFocused] = useState(false);

  useEffect(() => {
    if (resetKeyword) {
      setResetKeyword(false);
    }
  }, [resetKeyword, setResetKeyword]);

  return (
    <>
      <div
        className={classNames(
          "relative flex items-center h-12 w-full bg-white rounded-full overflow-hidden border transition-all duration-200",
          isFocused ? "border-text-disabled" : "border-text-secondary/50",
          divClasses
        )}
      >
        {iconPosition === "left" && (
          <div
            className={classNames(
              "w-10 h-10 flex-shrink-0 text-base flex items-center justify-center transition-all duration-200",
              iconClasses,
              isFocused
                ? "border-text-disabled text-deep-purple"
                : "border-text-secondary/50 text-text-secondary"
            )}
          >
            <i className={classNames("fa-fw", icon)}></i>
          </div>
        )}
        <input
          type="text"
          placeholder={placeholder}
          className={classNames(
            "font-CanelaDeck flex-shrink !border-0 w-full !ring-0 bg-transparent text-slate-800 placeholder:text-slate-400 placeholder:  text-sm    h-10 ",
            inputClasses,
            iconPosition === "left"
              ? "pr-4"
              : iconPosition === "right"
              ? "pl-4"
              : ""
          )}
          value={resetKeyword ? "" : searchValue}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => search(e.target.value)}
          onKeyDown={onKeyDown}
        />
        {iconPosition === "right" && (
          <div
            className={classNames(
              "w-10 h-10 flex-shrink-0 text-base flex items-center justify-center transition-all duration-200",
              iconClasses,
              isFocused
                ? "border-text-disabled text-deep-purple"
                : "border-text-secondary/50 text-text-secondary"
            )}
          >
            <i className={classNames("fa-fw", icon)}></i>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;
